<script>
import clientMixins from 'utils/client-mixins';
import { privileges } from 'domains/base/_base-enum';

export default {
  mixins: [clientMixins],
  props: {
    campaignId: String
  },
  data: () => ({
    privileged: false
  }),
  created() {
    if (!this.campaignId && this.hasPrivilege(privileges.PROMOTIONS)) {
      this.privileged = true;
    } else if (this.campaignId && this.hasPrivilege(privileges.CAMPAIGN_PROMOTIONS)) {
      this.privileged = true;
    } else {
      this.$router.replace('/');
    }
  },
};
</script>

<template lang='pug'>
.promotions(v-if='privileged')
  router-view(:key='$route.fullPath')
</template>

<style>
@import '~import/index';
@import '~styles/index';

.promotions {
  @extend %content-margin;
}
</style>